import React from "react";
import MonthlyDossier, { DEMO_REPORT } from "../components/report/MonthlyDossier";

// Design preview of the Elite Monthly Performance Report (mock data) — /print/dossier
export default function PrintDossier() {
  return (
    <div data-testid="print-dossier" className="bg-black min-h-screen">
      <MonthlyDossier r={DEMO_REPORT} />
    </div>
  );
}
